import {
  removeTenderDocumentFiles,
  uploadTenderDocumentFile,
} from '../../services/tenderDocumentFiles';
import { insertTenderDocuments } from '../../services/tenderDocuments';
import { notify } from '../../store/feedback';
import { endUpload, updateNoticeDocuments } from './uploadState';

/* Import manuel des documents d'un appel d'offres, puis analyse. */
export default function tenderDocumentsHandlers(deps, api) {
  const { guessAoDocumentType, sanitizeStorageFilename, session } = deps;
  const {
    setTenderUploadBusy,
    setTenderUploadIdweb,
    setTenderUploadProgress,
    setTenderUploadStepText,
    setModalData,
  } = deps;

  // Un fichier : extraction du texte (PDF), envoi dans Storage, ligne boamp_documents.
  // Renvoie la ligne créée, ou null en cas d'échec (alerte déjà affichée).
  async function uploadOne(idweb, file, label, progress) {
    let texte = '';
    if (file.name.toLowerCase().endsWith('.pdf')) {
      setTenderUploadStepText(`Lecture de ${file.name} ${label}`);
      progress(0);
      try {
        texte = await api.extractPdfText(file);
        console.log('[AO import] texte extrait', file.name, texte.length, 'caractères');
      } catch (e) {
        console.error('[AO import] extraction PDF échouée', file.name, e);
      }
    }
    setTenderUploadStepText(`Envoi de ${file.name} ${label}`);
    progress(1);
    const storagePath = `${idweb}/${Date.now()}_${sanitizeStorageFilename(file.name)}`;
    console.log('[AO import] upload storage…', storagePath);
    const { error: uploadErr } = await uploadTenderDocumentFile(file, storagePath);
    if (uploadErr) {
      console.error('[AO import] erreur upload storage', uploadErr);
      notify(`Erreur upload ${file.name} : ` + uploadErr.message);
      return null;
    }
    const type = guessAoDocumentType(file.name);
    const { data: docRow, error: insertErr } = await insertTenderDocuments(
      file,
      idweb,
      storagePath,
      texte,
      type,
    );
    if (insertErr) {
      console.error('[AO import] erreur insert boamp_documents', insertErr);
      notify(`Erreur enregistrement ${file.name} : ` + insertErr.message);
      return null;
    }
    console.log('[AO import] document enregistré', docRow);
    return docRow;
  }

  // Import manuel : extraction + upload Storage + insert boamp_documents (RLS via la session du
  // manager, pas de clé de service) puis appel à boamp-analyze avec le jeton de session.
  async function uploadTenderDocuments(idweb, fileList) {
    const files = Array.from(fileList || []);
    console.log(
      '[AO import] uploadAoDocuments démarré',
      idweb,
      files.map((f) => f.name),
    );
    if (!files.length) return;
    if (!session?.access_token) return void notify('Session expirée, reconnectez-vous.');
    setTenderUploadBusy(true);
    setTenderUploadIdweb(idweb);
    const totalUnits = files.length * 2; // extraction + envoi, par fichier — l'analyse LLM qui suit est indéterminée
    let doneUnits = 0;
    const progress = (step) => {
      doneUnits += step;
      setTenderUploadProgress(doneUnits / totalUnits);
    };
    try {
      const uploaded = [];
      for (const [idx, file] of files.entries()) {
        const docRow = await uploadOne(idweb, file, `(${idx + 1}/${files.length})`, progress);
        if (!docRow) continue;
        uploaded.push(docRow);
        progress(1);
      }
      if (!uploaded.length)
        return void console.warn(
          '[AO import] aucun document effectivement importé, arrêt avant analyse',
        );
      updateNoticeDocuments(deps, idweb, (docs) => [...docs, ...uploaded]);
      await api.runTenderAnalysis(idweb);
    } finally {
      endUpload(deps);
    }
  }

  return { uploadTenderDocuments };
}
